import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-training-result-editor',
  templateUrl: 'training-result-editor.html',
})
export class TrainingResultEditorPage {
  lineUp: any;
  debug = false;
  rate: any  = {};
  goalsTeamRed: number = 0;
  goalsTeamBlack: number = 0;

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController) {
    this.lineUp = navParams.data;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TrainingResultEditorPage');
  }

  closeModal() {
    this.navCtrl.pop();
  }

  saveModal() {
    console.log("Rate: " + this.rate);
    console.log("Goals red: " + this.goalsTeamRed);
    console.log("Goals black: " + this.goalsTeamBlack);

    var result = {
      "rate" : this.rate,
      "goalsTeamRed" : this.goalsTeamRed,
      "goalsTeamBlack" : this.goalsTeamBlack
    };

    this.lineUp.value.result = result;

    this.viewCtrl.dismiss(this.lineUp);
  }
}



// WEBPACK FOOTER //
// ./src/pages/training-result-editor/training-result-editor.ts